import UserData from "./UserData";
import AppUtils from "../control/apputlis";
import Apis from "../network/Apis";
import MatchType from "./MatchType";
import TIMUtils from "../network/TIMUtils";
import DeviceEventEmitter, { EventName } from "../control/event";
import AppConfig from "../control/config";
import DateUtils from "../control/dateutils";

export default class AppData {
    static me = new UserData();
    static InviteCode = '';
    static FastKey = '';
    static schedusMatchData = [];
    static schedusTypeData = [];
    static starMatchData = [];
    static starAnchorData = null;
    static starLeagueData = null;
    static shareConfigData = null;
    static recommAnchorData = [];
    static TypeHostRecomm = [];
    static MsgShield = []; // 关键字
    static ServerConfig = null;
    static Location = ['北京'];
    static IsCloseChat = false;

    static isLoadingStarAnchor = false;
    static isLoadingStarLeague = false;
    static isLoadingStarMatch = [false, false, false];

    static ShareUrl = '';
    static ShareIcon = '';
    static ShareTittle = '';
    static ShareContent = '';

    static lastReqUpdateTime = 0;

    static setSchedusTypeData(data) {
        AppData.schedusTypeData = data;
    }

    static getSchedusTypeData() {
        return AppData.schedusTypeData ? AppData.schedusTypeData : [];
    }

    static setSchedusMatchData(type_id, data) {
        AppData.schedusMatchData[type_id] = data;
    }

    static getSchedusMatchData(type_id) {
        return AppData.schedusMatchData[type_id] ? AppData.schedusMatchData[type_id] : [];
    }


    static paserLogin(result) {
        var user = result;
        AppData.me.Uid = user.id;
        AppData.me.Username = user.username;
        AppData.me.PhoneNum = result.phone;
        AppData.me.PcToken = user.pc_token;
        AppData.me.Pic = user.portrait;
        AppData.me.RealStatus = user.real_status;//实名认证状态（1：已经认证，2：没有认证）
    }

    static logout() {
        AppData.me.Uid = 0;
        AppData.me.Username = "";
        AppData.me.PhoneNum = "";
        AppData.me.PcToken = "";
        AppData.me.Pic = "";
        AppData.me.RealStatus = 2;//实名认证状态（1：已经认证，2：没有认证）
        AppData.me.token = '';
        AppData.me.customer_id = 0;
        localStorage.setItem("user_token", null);
        localStorage.setItem("user_customer_id", null);

        AppData.schedusMatchData = [];
        AppData.schedusTypeData = [];
        AppData.starMatchData = [];
        AppData.starAnchorData = null;
        AppData.starLeagueData = null;
        AppData.shareConfigData = null;
        AppData.imLoginout();
    }

    static imLoginout() {
        TIMUtils.logout(function () {
            AppData.encryptionTourists();
        });
    }

    static loginIn() {
        AppData.me.userSign = '';
        TIMUtils.logout(function () {
            AppData.getUserInfo();
        });
    }

    static login() {
        let token = AppUtils.getStorageItem("user_token");
        let customer_id = AppUtils.getStorageItem("user_customer_id");
        let phone_num = AppUtils.getStorageItem('phone_num');
        if (token && token.length > 0 && customer_id && customer_id > 0 && token != 'null' && customer_id != 'null') {
            AppData.me.token = token;
            AppData.me.customer_id = customer_id;
            AppData.me.PhoneNum = phone_num;
            AppData.getUserInfo();
            AppData.reqHeatBeat();
            AppData.getMsgShield();
            AppData.getServerConfig();
        } else {
            if (!AppData.me.userSign || AppData.me.userSign == '') {
                AppData.encryptionTourists();
            }
            DeviceEventEmitter.emit(EventName.EVENT_UPDATE_USERINFO);
        }

    }

    static isStarMatch(type_id, matchId) {
        if (AppData.starMatchData && AppData.starMatchData[type_id]) {
            let data = AppData.starMatchData[type_id];
            for (let i = 0; i < data.length; i++) {
                if (data[i].id == matchId) {
                    return true;
                }
            }
        }
        return false;
    }

    static isStarAnchor(anchor) {
        if (AppData.starAnchorData && AppData.starAnchorData.length > 0) {
            for (let i = 0; i < AppData.starAnchorData.length; i++) {
                const element = AppData.starAnchorData[i];
                if (anchor == element.user_id) {
                    return true;
                }
            }
        }
        return false;
    }

    static starAnchor() {
        if (AppData.isLoadingStarAnchor) {
            return;
        }
        if (!AppData.me.isLogin()) {
            return;
        }
        AppData.isLoadingStarAnchor = true;
        AppData.getStarAnchor();
    }

    static starLeague() {
        if (AppData.isLoadingStarLeague) {
            return;
        }
        if (!AppData.me.isLogin()) {
            return;
        }
        AppData.isLoadingStarLeague = true;
        AppData.getStarLeague();
    }

    static starMatch(type_id) {
        if (AppData.isLoadingStarMatch[type_id]) {
            return;
        }
        if (!AppData.me.isLogin()) {
            return;
        }
        AppData.isLoadingStarMatch[type_id] = true;
        AppData.getStarMatch(type_id);
    }

    static getStarAnchor = async () => {
        let result = await Apis.encryptionShowFocusHost();
        console.log('getStarAnchor', result);
        if (result.code == 200) {
            AppData.starAnchorData = result.data;
            DeviceEventEmitter.emit(EventName.EVENT_UPDATE_USERINFO);
        }
    }

    static getStarLeague = async () => {
        let result = await Apis.encryptionShowFocusLeague();
        console.log('getStarLeague', result);
        if (result.code == 200) {
            let data = result.data.sort((a, b) => {
                return b.count - a.count;
            })
            AppData.starLeagueData = data;
            DeviceEventEmitter.emit(EventName.EVENT_UPDATE_USERINFO);
        }
    }

    static getStarMatch = async (type_id) => {
        let result = await Apis.encryptionShowFocusEvent(type_id);
        console.log('getStarMatch', result);
        if (result.code == 200) {
            AppData.starMatchData[type_id] = result.data;
            DeviceEventEmitter.emit(EventName.EVENT_UPDATE_USERINFO);
        }
    }

    static encryptionTourists = async () => {
        let result = await Apis.encryptionTourists(AppConfig.deviceid, window.location.href);
        console.log('encryptionTourists', result);
        if (result.code == 200) {
            AppData.me.identifier = result.data.identifier;
            AppData.me.userSign = result.data.userSig;
            // TIMUtils.init();
            AppData.initTim();
            //TIMUtils.login(AppData.me.identifier, AppData.me.userSign);
            AppData.reqHeatBeat();
            AppData.getMsgShield();
            AppData.getServerConfig();

            DeviceEventEmitter.emit(EventName.EVENT_UPDATE_USERINFO);
        }
    }

    static getUserInfo = async () => {
        let result = await Apis.encryptionShowCustomer();
        console.log('getUserInfo', result);
        if (result.code == 200) {
            AppData.paserLogin(result.data);
            AppData.sync();
            AppData.getUserSig();
        } else {
            DeviceEventEmitter.emit(EventName.EVENT_UPDATE_USERINFO);
        }
    }

    static getUserSig = async () => {
        if (AppData.me.userSign != '' && AppData.me.identifier != '') {
            // TIMUtils.init();
            AppData.initTim();
            //TIMUtils.login(AppData.me.identifier, AppData.me.userSign);
        } else {
            let result = await Apis.encryptionSign(AppData.me.Uid);
            console.log('getUserSig', result);
            if (result.code == 200) {
                AppData.me.identifier = TIMUtils.getChatId(AppData.me.Uid);
                AppData.me.userSign = result.data;
                // TIMUtils.init();
                AppData.initTim();
                //TIMUtils.login(AppData.me.identifier, AppData.me.userSign);
            }
        }
    }

    static sync() {
        AppData.starMatch(MatchType.FOOTBALL)
        AppData.starMatch(MatchType.BASKETBALL)
        AppData.starAnchor();
        AppData.starLeague();
        AppData.getShareConfig();
    }

    static checkUpdate = async () => {
        let now = DateUtils.getCurTime();
        if ((now - AppData.lastReqUpdateTime) > 60 * 1000) {
            let result = await Apis.encryptionVersion(AppConfig.version);
            console.log('checkUpdate', result);
            if (result.code == 200 && result.data && result.data.version) {
                if (AppConfig.version < Number(result.data.version)) {
                    window.location.reload(true);
                }
            }
            AppData.lastReqUpdateTime = now;
        }
    }

    static heatBeat() {
        if (AppData.heatBeatInterval) {
            return;
        }
        AppData.heatBeatInterval = setInterval(() => {
            AppData.reqHeatBeat();
        }, 3 * 1000 * 60);
    }

    static async reqHeatBeat() {
        if (!AppData.me.identifier && !AppData.me.customer_id) {
            return;
        }
        let usertype = 1;
        if (AppData.me.isLogin()) {
            usertype = 2;
        }
        let userId = 1;
        if (AppData.me.customer_id > 0) {
            userId = AppData.me.customer_id;
        } else {
            if (AppData.me.identifier.startsWith('tourists_')) {
                userId = AppData.me.identifier.substring('tourists_'.length);
            }
        }
        let phone = AppData.me.PhoneNum;
        let phone_code = AppConfig.deviceid;

        let res = await Apis.encryptionHeartLog(usertype, userId, phone, phone_code);
        console.log('heatBeat', res);
    }



    static async getMsgShield() {
        if (AppData.MsgShield && AppData.MsgShield.length > 0) {
            return;
        }
        let result = await Apis.encryptionMsgShield();
        console.log('getMsgShield', result);
        if (result.code == 200) {
            AppData.MsgShield = result.data;
        }
    }

    static keywordShield(str) {
        if (str.length < 1) {
            return str;
        }

        if (AppData.MsgShield.length == 0) {
            return str;
        }


        String.prototype.replaceAll = function (s1, s2) {
            return this.replace(new RegExp(s1, "gm"), s2);
        }

        for (let i = 0; i < AppData.MsgShield.length; i++) {
            let star = '';
            let tmp = AppData.MsgShield[i];
            for (let j = 0; j < tmp.length; j++) {
                star += "*";
            }
            str = str.replaceAll(AppData.MsgShield[i], star);
        }
        return str;
    }


    static async getServerConfig() {
        if (AppData.ServerConfig) {
            return;
        }
        let res = await Apis.encryptionServerConfig();
        console.log("encryptionServerConfig", res);
        if (res.code == 200 && res.data) {
            AppData.ServerConfig = res.data;
        }
    }

    static isOutOfDate(time) {
        let curtime = DateUtils.getCurTime();
        let tmep = (time + AppData.ServerConfig.private_message_over * 24 * 60 * 60) * 1000;
        return curtime > tmep;
    }

    static getLocation() {
        console.log('getLocation', navigator.geolocation);
        var BMap = window.BMap;
        if (BMap) {
            var geoc = new BMap.Geocoder();
            var geolocation = new BMap.Geolocation();
            geolocation.getCurrentPosition(function (r) {
                geoc.getLocation(r.point, function (rs) {
                    console.log(rs)
                    if (rs && rs.addressComponents && rs.addressComponents.city) {
                        var addComp = rs.addressComponents;
                        let cityName = addComp.city;
                        let exist = false;
                        for (let i = 0; i < AppData.Location.length; i++) {
                            if (cityName && cityName.indexOf(AppData.Location[i]) >= 0) {
                                exist = true;
                            }
                        }

                        if (exist) {
                            AppData.IsCloseChat = true;
                        }
                    }
                });
            });
        }
        else {
            console.log('getLocation', navigator.geolocation);
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    AppData.getCity(position);
                });
            }
        }
    }

    static async getCity(position) {
        let lat = position.coords.latitude;
        let lng = position.coords.longitude;
        let result = await Apis.encryptionGetCity(lat, lng);
        console.log('getCity', result);
        if (result && result.code == 200) {
            result = result.data;
            if (result && result.status == 'OK') {
                if (result.result && result.result.addressComponent && result.result.addressComponent.city) {
                    let city = result.result.addressComponent.city;
                    let exist = false;
                    for (let i = 0; i < AppData.Location.length; i++) {
                        if (city && city.indexOf(AppData.Location[i]) >= 0) {
                            exist = true;
                        }
                    }
                    if (exist) {
                        AppData.IsCloseChat = true;
                    }
                }
            }
        }
    }

    static getShareConfig = async () => {
        if (AppData.ShareUrl.length > 0) {
            return;
        }
        let result = await Apis.encryptionConfig();
        if (result.code == 200) {
            AppData.ShareUrl = result.data.download_url;
            AppData.ShareIcon = result.data.share_icon;
            AppData.ShareTittle = result.data.share_title;
            AppData.ShareContent = result.data.share_text;
        }
    }

    static initTim() {
        if (AppData.ServerConfig && AppData.ServerConfig.im_key && AppData.ServerConfig.im_key > 0) {
            TIMUtils.init(AppData.ServerConfig.im_key)
            TIMUtils.login(AppData.me.identifier, AppData.me.userSign);
        } else {
            AppData.getServerConfig()
        }
    }
}
